<template>
  <section class="page-container">
    <div class="flex flex-align-center flex-sb-center">
      <div class="total">
        <div
          class="item">
          <span class="num">{{fi_count}}</span>
          <span>Fire</span>
        </div>
        <div
          class="item">
          <span class="num">{{hd_count}}</span>
          <span>Home</span>
        </div>

      </div>
    </div>
    <div class="filter-top">
      <!--      <span>Search</span>-->
      <v-input
        v-model="search"
        placeholder="Policy No., Cover Note No., HCID, Endorsement No., Customer Name, Contact, Referrer, VRD, ID No."
        @keyEnter="filterData" />
    </div>
    <div class="filter-card">
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Creation Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="filterData" />
          </div>
          <!--          <div class="form-item">-->
          <!--            <span>Issue Date</span>-->
          <!--            <v-date-picker-->
          <!--              v-model="effective_date"-->
          <!--              type="daterange"-->
          <!--              @change="filterData" />-->
          <!--          </div>-->
          <div class="form-item">
            <span>Effective Start Date</span>
            <v-date-picker
              v-model="effective_date"
              type="daterange"
              @change="filterData" />
          </div>
          <div class="form-item">
            <span>Effective End Date</span>
            <v-date-picker
              v-model="effective_end_date"
              type="daterange"
              @change="filterData" />
          </div>
          <div class="form-item">
            <span>
              Insurer
              <span
                v-if="company_id.length"
                class="all"
                @click="handlerNoneAll('company_id')">None</span>
            </span>
            <span >
              <v-select
                v-model="company_id"
                placeholder="All"
                multiple
                :list="insurerList"
                has-icon
                @change="filterData">
                <template #default="{item}">
                  <span class="flex-align-center select-icon-center">
                    <span class="icon">
                      <img
                        v-if="getOptionData('companySmallIcon', item.id).logo"
                        :src="getOptionData('companySmallIcon', item.id).logo? getOptionData('companySmallIcon', item.id).logo:''"/>
                    </span>
                    <span>{{item.name}}</span>
                  </span>
                </template>
              </v-select>
            </span>
          </div>
          <div class="form-item">
            <span>
              Code
            </span>
            <span>
              <v-input
                v-model="campaign_code"
                @change="filterData" />
            </span>
          </div>
        </div>
        <div class="filter-middler">
          <div class="form-item">
            <span>
              Status
              <span
                class="all"
                @click="handlerSelectAll('stts')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('stts')">None</span>            </span>
            <v-checkbox-group
              v-model="stts"
              :list="statusOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex flex-align-center">
                  <span
                    class="circle"
                    :class="{
                      'red': item.id == 0,
                      'orange': item.id == 1,
                      'yellow-dark': item.id == 2,
                      'blue': item.id == 3,
                      'green': item.id == 4
                    }"></span>
                  <span>{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
          <div class="form-item">
            <span>
              Effectiveness
              <span
                class="all"
                @click="handlerSelectAll('effe_id')">All</span>
              <span
                class="all"
                @click="handlerNoneAll('effe_id')">None</span>            </span>
            <v-checkbox-group
              v-model="effe_id"
              :list="effeOptions"
              :isColumn="false"
              @change="filterData">
              <template #default="{ item }">
                <span class="flex-align-center">
                  <span
                    class="span-options"
                    :class="{
                      'gray': item.id == 1,
                      'green': item.id == 2,
                      'red': item.id == 3
                    }">{{ item['name'] }}</span>
                </span>
              </template>
            </v-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <div class="transparent">
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="'table-pointer'"
        :header-row-class-name="'tableHeader'"
      >
        <el-table-column
          width="60px"
          align="center">
          <template>
            <div
              class="flex-algin"
            >
              <p class="icon icon-text">
                <font-awesome-icon
                  icon="gift"
                  class="icon-color"/>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="105px"
          label="Created Date">
          <template #default="{row}">
            <div class="flex-algin fs-12 time-text">
              <span>{{ row.created_date.split(" ")[0]}}</span><br>
              <span> {{ row.created_date.split(" ")[1]}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Code">
          <template #default="{row}">
            <span >{{row.campaign_code}}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="70"
          prop="id"
        >
          <template #default="{ row }">
            <div
              v-if="row.main_order_id!=null"
              class="flex-algin">
              <span>
                <div class="flex  table-icon">
                  <div v-if="row.main_company_id">
                    <span
                      class="icon icon-content"
                    >
                      <img
                        :src="getOptionData('companySmallIcon', row.main_company_id).logo? getOptionData('companySmallIcon', row.main_company_id).logo: row.main_company_logo"
                      >
                    </span>
                  </div>
                  <div>
                    <span
                      class="icon icon-content"
                    >
                      <font-awesome-icon
                        :icon="getOptionName('iconOptions', 29)" />
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Policy">
          <template #default="{ row }">
            <div
              v-if="row.main_order_id!=null"
              class="flex-algin"
              @click="rowClick(row)" >
              <span
                class="showLick"
              >
                <span class="span-label">{{ row.main_plan }}</span>
              </span>
              <p
                v-if="row.main_pcy_no"
                class="phone-text">
                <span ><span class="weight-text">Policy No. </span> {{ row.main_pcy_no }}&nbsp;&nbsp;&nbsp;</span>
              </p>
              <p
                v-if="row.main_order_sn"
                class="phone-text">
                <template><span class="weight-text"> Ref. </span>{{ row.main_order_sn }}</template>
              </p>
              <p class="status-height">
                <span
                  class="span-status"
                  :class="{
                    'red': [801, 0].includes(row.main_stts),
                    'orange': [401, 301].includes(row.main_stts),
                    'yellow-dark': [410, 501, 701].includes(row.main_stts),
                    'blue': [420, 505, 705,250].includes(row.main_stts),
                    'green': [425, 510, 710].includes(row.main_stts)
                  }">
                  {{ row.main_stts_language }}
                </span>
              </p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="70"
          prop="id"
        >
          <template #default="{ row }">
            <div
              v-if="row.gift_order_id!=null"
              class="flex-algin">
              <span>
                <div class="flex  table-icon">
                  <div v-if="row.gift_company_id">
                    <span
                      class="icon icon-content"
                    >
                      <img
                        :src="getOptionData('companySmallIcon', row.gift_company_id).logo? getOptionData('companySmallIcon', row.gift_company_id).logo: row.gift_company_logo"
                      >
                    </span>
                  </div>
                  <div>
                    <span
                      class="icon icon-content"
                    >
                      <font-awesome-icon
                        :icon="getOptionName('iconOptions', 26)" />
                    </span>
                  </div>
                </div>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="Gift">
          <template #default="{ row }">
            <div
              v-if="row.gift_order_id!=null"
              class="flex-algin"
              @click="rowGiftClick(row)" >
              <span
                class="showLick"
              >
                <span class="span-label">{{ row.gift_plan }}</span>
              </span>
              <p
                v-if="row.gift_pcy_no"
                class="phone-text">
                <span ><span class="weight-text">Policy No. </span> {{ row.gift_pcy_no }}</span>
              </p>
              <p
                v-if="row.gift_order_sn"
                class="phone-text">
                <template><span class="weight-text"> Ref. </span>{{ row.gift_order_sn }}</template>
              </p>
              <p class="status-height">
                <span
                  class="span-status"
                  :class="{
                    'red': [801, 0].includes(row.gift_stts),
                    'orange': [401, 301].includes(row.gift_stts),
                    'yellow-dark': [410, 501, 701].includes(row.gift_stts),
                    'blue': [420, 505, 705,250].includes(row.gift_stts),
                    'green': [425, 510, 710].includes(row.gift_stts)
                  }">
                  {{ row.gift_stts_language }}
                </span>
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange" />
  </section>
</template>

<script>
import {getHomeFireList} from '@/api/home-fire'
import {mapActions, mapState} from 'vuex'
import {downloadFile} from '@/utils/download'
import MixinOptions from '@/mixins/options'
import MinxinFormat from '@/mixins/format'

export default {
  name: 'homeFireList',
  components:{
  },
  mixins: [MixinOptions,MinxinFormat],
  data () {
    return {
      search: null,
      hd_count: 0,
      fi_count: 0,
      date: [],
      effective_end_date: [],
      effective_date: [],
      company_id: [],
      campaign_code: '',
      status: [],
      effe_id:[],
      stts:[],
      tableData:[],
      pageConfig:{
        total: 0,
        currentPage: 1
      },
      summary:[],
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData']),
    statusOptions() {
      return this.globalOptions.new_pcy_stts
    },
    effeOptions() {
      return this.globalOptions.effectiveness
    },
    insurerList(){
      let arr = JSON.parse(JSON.stringify(this.insurerAllOptions))
      // arr.unshift({id: 0, name: 'All'})
      return arr
    },
  },
  watch:{
    property: {
      immediate: true,
      handler() {
        let {policy={}} =  this.selectFilterData||{}
        Object.keys(policy).forEach(item=>{
          this[item] = policy[item]
        })
        this.setFilterData(policy||{})
        this.network().getList()
      }
    },
    date:{
      immediate: true,
      handler(){
        this.$emit('changeDate',this.date)
      }
    },
  },
  async mounted(){
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    handleRow(row){
      const { id, class_id, product_id} = row
      this.$router.push(`/records/micropolicy/car-bomb/${id}`)
    },
    changeDate(){
      this.$emit('changeDate',this.date)
      this.filterData()
    },

    currentChange(page){
      this.pageConfig.currentPage = page
      this.network().getList()
    },
    handleRefresh(){
      this.filterData()
    },
    filterData(){
      this.pageConfig.currentPage = 1
      this.network().getList()
    },

    handlerSelectAll(target){
      let origin = ''
      switch(target) {
        case 'stts':
          origin = 'statusOptions'
          break
        case 'effe_id':
          origin = 'effeOptions'
          break
        default:
          break
      }
      const data = this[origin].reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this[target] = data
      this.filterData()
    },

    handlerNoneAll(target){
      this[target] = []
      this.filterData()
    },
    handlerDown() {
      this.network().getList({
        is_export: 1
      })
    },
    rowClick(row) {
      const { main_order_id, main_product_id,main_pcy_id,class_id,sme_versions } = row
      this.$router.push({
        path: '/records/policy/detail',
        query: {
          id:main_order_id,
          product_id:main_product_id,
          pcy_id:main_pcy_id
        }
      })
    },
    rowGiftClick(row) {
      const { gift_pcy_id,gift_order_id, gift_product_id,main_pcy_id,class_id,sme_versions } = row
      let path = ''
      if(gift_pcy_id<=0){
        path = '/records/quote/detail'
        this.$router.push({
          path: path,
          query: {
            order_id:gift_order_id,
            product_id:gift_product_id,
          }
        })
      }else {
        path = '/records/policy/detail'
        this.$router.push({
          path: path,
          query: {
            id:gift_order_id,
            product_id:gift_product_id,
            pcy_id:gift_pcy_id
          }
        })
      }

    },
    network(){
      return {
        getList: async (otherParams) => {
          let params = {
            created_start: this.date[0],
            created_end: this.date[1],
            page: this.pageConfig.currentPage,
            search: this.search,
            company_id: this.company_id,
            stts: this.stts,
            campaign_code: this.campaign_code,
            effe_id: this.effe_id,
            cmnt_dt: this.effective_date[0],
            expry_dt: this.effective_date[1],
            start_expry_dt : this.effective_end_date[0],
            end_expry_dt : this.effective_end_date[1],
            ...otherParams
          }
          if(otherParams && otherParams.is_export == 1){
            const res = await getHomeFireList(params,{
              responseType: 'blob',
              timeout: 120000
            })
            downloadFile(res)
          }else
          {
            const { data } = await getHomeFireList(params)
            this.pageConfig.currentPage = data.current_page
            let {total,fi_count,hd_count} = data||{}
            this.pageConfig.total = total
            this.tableData = data.data
            this.hd_count = hd_count||0
            this.fi_count = fi_count||0
          }
        }
      }
    }
  },
}
</script>
<style lang='scss' scoped>
@import '../../../../../assets/css/mic-list';
.phone-text{
  font-size: 12px;
  color: #6A737D;
  .weight-text{
    font-weight: 600;
  }
}
</style>
